import { useRef } from 'react';
import { Container, HStack, IconButton, Drawer, CloseButton, Portal } from '@chakra-ui/react';
import type { ContainerProps } from '@chakra-ui/react';
import { LuAlignRight } from 'react-icons/lu';
import { Link } from 'react-router';
import Logo from '@components/Logo';

import Sidebar from './Sidebar';

const Navbar = (props: ContainerProps) => {
  const closeButtonRef = useRef<HTMLButtonElement>(null);

  const handleCloseDrawer = () => {
    closeButtonRef.current?.click();
  };

  return (
    <Container py="2.5" bg="grayscale" {...props}>
      <HStack justify="space-between">
        <Link to="/painel">
          <Logo width={100} />
        </Link>
        <Drawer.Root placement="start">
          <Drawer.Trigger asChild>
            <IconButton aria-label="Open Menu" variant="ghost" colorPalette="gray">
              <LuAlignRight />
            </IconButton>
          </Drawer.Trigger>
          <Portal>
            <Drawer.Backdrop />
            <Drawer.Positioner>
              <Drawer.Content>
                <Drawer.CloseTrigger asChild>
                  <CloseButton size="sm" colorPalette="gray" ref={closeButtonRef} />
                </Drawer.CloseTrigger>
                <Sidebar onClose={handleCloseDrawer} />
              </Drawer.Content>
            </Drawer.Positioner>
          </Portal>
        </Drawer.Root>
      </HStack>
    </Container>
  );
};

export default Navbar;
